import { useMemo } from 'react';

import { Grid, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { CaretRight } from 'phosphor-react';

import Link from '~components/shared/link';
import { primaryColors } from '~components/theme/styles/colors';

export type PageTitleBreadcrumbPaths = { text: string; href: string; isNavigatable: boolean }[];

const navigationExclusions = ['stability', 'liquidity', 'v2', ''];

function getPaths(fullPath: string) {
  let reconstructedPath = '';
  const splitPath = fullPath.split('/');

  return splitPath.map((path, index) => {
    const lastPath = reconstructedPath;
    reconstructedPath += `${path}${splitPath.length - 1 > index ? '/' : ''}`;

    return navigationExclusions.includes(path)
      ? { text: path, href: lastPath, isNavigatable: false }
      : { text: path, href: reconstructedPath, isNavigatable: true };
  });
}

function sanitize(lp: string) {
  return lp.replaceAll('_', ' ');
}

export const PageTitleBreadcrumbs = () => {
  const router = useRouter();
  const paths = useMemo(() => getPaths(router.asPath), [router.asPath]);

  return (
    <Grid container sx={{ gap: '8px', alignItems: 'center' }}>
      {paths.map(({ text, href, isNavigatable }, index) =>
        isNavigatable ? (
          <Link href={href} key={text}>
            <Grid sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography
                variant="label3"
                sx={{
                  color: index === paths.length - 1 ? primaryColors['400'] : primaryColors['700'],
                  transition: 'color 0.05s linear',
                  '&:hover': {
                    color: isNavigatable ? primaryColors['400'] : primaryColors['700'],
                    cursor: index === paths.length - 1 ? 'default' : 'pointer',
                  },
                }}
              >
                {sanitize(text.toUpperCase())}
              </Typography>
              {index !== paths.length - 1 && <CaretRight color={primaryColors['700']} size={16} />}
            </Grid>
          </Link>
        ) : null,
      )}
    </Grid>
  );
};
